import { hasPermission } from "thriller-core/Permissions";
import { b64DecodeUnicode } from "./Utils";

export async function checkPermission(user, permission) {
  if (!user.email || !user.emailVerified) return false;
  const idToken = await user.getIdToken();
  const claims = JSON.parse(b64DecodeUnicode(idToken.split(".")[1]));
  return claims.admin ? hasPermission(claims.admin, permission) : false;
}



// WEBPACK FOOTER //
// ./src/lib/Permissions.js